import React from "react";

const Privacy = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: April 2025</p>

      <p>
        At ChiSquareAI, we value your privacy. This Privacy Policy describes
        how we collect, use, and share information when you use our service.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect the following types of information:
        <ul>
          <li>Your email address when you sign up or subscribe</li>
          <li>Sales data and revenue metrics from connected platforms (e.g., Stripe)</li>
          <li>Product information and analytics data</li>
          <li>Real-time data from third-party APIs (e.g., Twitter, Reddit, YouTube)</li>
        </ul>
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use collected data to:
        <ul>
          <li>Generate sales forecasts and product recommendations</li>
          <li>Visualize business performance using AI-powered models</li>
          <li>Improve our services and develop new features</li>
          <li>Communicate important updates and support messages</li>
        </ul>
      </p>

      <h2>3. Data Sharing</h2>
      <p>
        We do not sell your personal data. We may share it with trusted service providers only for the purposes listed above.
      </p>

      <h2>4. Third-Party Services</h2>
      <p>
        Our service integrates with third-party platforms (like Stripe, Twitter, YouTube, Reddit). These services have their own privacy policies which you should review.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We use commercially reasonable measures to secure your information.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You may request access to or deletion of your personal data by contacting us at: support@chisquare.io.
      </p>

      <h2>7. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page.
      </p>
    </div>
  );
};

export default Privacy;